import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Dossier } from '../shared/dossier/dossier';
import { PageTitle } from '../shared/page-title/page-title';

// Acces refuse : joueur sans jeton valide (perdu, revoque) ou organisateur sans droit.
// Un joueur qui a perdu son jeton en recoit un nouveau de l'organisateur (TD-017).
@Component({
  selector: 'app-not-authorized',
  imports: [Dossier, PageTitle, RouterLink],
  templateUrl: './not-authorized.html',
})
export class NotAuthorized {}
